export default {
    RECEIVE_HARBOURS: 'RECEIVE_HARBOURS',
    RECEIVE_HARBOUR: 'RECEIVE_HARBOUR',
    DELETE_HARBOUR: 'DELETE_HARBOUR',
}
